/* eslint-disable no-unused-vars */

import moment from 'moment';

import { PERMISSIONS } from 'permissions/constants';
import TasksSelector from 'selectors/tasks/tasks.selector';
import InspectionSelector from 'selectors/inspection/inspection.selector';
import CheckSelector from 'selectors/checks/check.selector';
import HSEEventSelector from 'selectors/hse/hse-event.selector';

export const taskTypeData = async ({ store, permissions }) => {
  const { auth, cache } = store;
  const userId = auth.userId || '';
  const allWOTasks = (await TasksSelector.getTasks({ store })) || [];

  const allAssignedWorkOrders = allWOTasks?.filter((task) =>
    task.newWorkOrder && task?.status !== 'To do'
      ? task?.responsible?.[0]?.woUserRequestId === userId
        ? true
        : false
      : task?.status === 'Synced'
      ? !task?.isNew
        ? true
        : false
      : !task.newWorkRequest
  );

  const newWorkOrderList = allWOTasks?.filter((task) =>
    (task.newWorkOrder || task?.entityType === 'WorkOrder') &&
    task?.responsible?.[0]?.woUserRequestId !== userId &&
    task?.status !== 'To do' &&
    task?.status !== 'Synced'
      ? true
      : task?.status === 'Synced' && task?.isNew && task?.entityType !== 'WorkRequest'
      ? true
      : false
  );

  const newWorkRequestList =
    allWOTasks?.filter((task) => task.newWorkRequest || task?.entityType === 'WorkRequest') || [];

  const allDoneWOTasks = allAssignedWorkOrders.filter((task) => task?.status === 'Synced');
  const allNotDoneWOTasks = allAssignedWorkOrders.filter((task) => task?.status !== 'Synced');

  const allInspectionTasks = (await InspectionSelector.getInspections({ store })) || [];
  const allDoneInspectionTasks = allInspectionTasks.filter((task) => task?.status === 'Synced');
  const allNotDoneInspectionTasks = allInspectionTasks.filter((task) => task?.status !== 'Synced');

  const allCheckTasks = (await CheckSelector.getAllChecks({ store })) || [];
  const allDoneCheckTasks = allCheckTasks.filter((task) => task?.status === 'Synced');
  const allNotDoneCheckTasks = allCheckTasks.filter((task) => task?.status !== 'Synced');

  const allHseEvents = (await HSEEventSelector.getHSEEvents({ store })) || [];

  const allTasksList = allTasksWithPermissions({
    permissions,
    allWOTasks,
    allInspectionTasks,
    allCheckTasks
  });
  const allDoneTasks = allTasksList.filter((task) => task?.status === 'Synced');
  const allNotDoneTasks = allTasksList.filter((task) => task?.status !== 'Synced');

  const today = moment().format('YYYY-MM-DD');
  const isOverDue = allNotDoneTasks.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const isWOOverDue = allNotDoneWOTasks.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const IsInspectionOverDue = allNotDoneInspectionTasks.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const IsCheckOverDue = allCheckTasks.find((task) =>
    task.dueDate ? moment(task.nextDue).isBefore(today) : false
  );

  // New or edited assets count

  const {
    equipments: cacheEquipments = [],
    sitesMap,
    sites,
    sitesEquipmentsMap = {},
    syncedNewAndEditedEquipments = []
  } = cache;

  let editEquipmentCount =
    cacheEquipments?.filter((equipment) => equipment.equipmentEditingStatus) || [];

  editEquipmentCount = [...editEquipmentCount, ...syncedNewAndEditedEquipments];

  const equipmentSitesIds = [...new Set(editEquipmentCount?.map((x) => x?.siteId) || [])];
  const equipmentIds = editEquipmentCount?.map((x) => x?.equipmentId) || [];
  console.log({ equipmentSitesIds, equipmentIds });

  let sitesCount = equipmentSitesIds?.length || 0;

  for (let siteId of equipmentSitesIds) {
    const { children = [], parentSiteId = '' } = sites[sitesMap[siteId]] || {};
    const { children: parentSiteIdChildren = [] } = sites[sitesMap[parentSiteId]] || {};

    if (
      parentSiteId &&
      !equipmentSitesIds?.includes(parentSiteId) &&
      parentSiteIdChildren?.length > 0
    ) {
      sitesCount += 1;
    }
  }

  return {
    allWOTasks,
    newWorkOrderList,
    newWorkRequestList,
    allDoneWOTasks,
    allInspectionTasks,
    allDoneInspectionTasks,
    allDoneCheckTasks,
    allNotDoneCheckTasks,
    allCheckTasks,
    allTasks: allTasksList,
    allDoneTasks,
    isOverDue,
    isWOOverDue,
    IsInspectionOverDue,
    IsCheckOverDue,
    allHseEvents,
    editEquipmentCount,
    editEquipmentViewBySitesCount: sitesCount
  };
};

const allTasksWithPermissions = ({
  permissions,
  allWOTasks,
  allInspectionTasks,
  allCheckTasks
}) => {
  let allTasks = [];
  if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
  )
    allTasks = [...allWOTasks, ...allInspectionTasks, ...allCheckTasks];
  else if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
  )
    allTasks = [...allCheckTasks, ...allWOTasks];
  else if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] &&
    permissions[PERMISSIONS.allCheckTasks]
  )
    allTasks = [...allInspectionTasks, ...allCheckTasks];
  else if (
    permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] &&
    permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
  )
    allTasks = [...allInspectionTasks, ...allWOTasks];
  else if (permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS]) allTasks = [...allInspectionTasks];
  else if (permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]) allTasks = [...allWOTasks];
  else if (permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS]) allTasks = [...allCheckTasks];
  return allTasks;
};
